module.exports = __webpack_public_path__ + "static/img/gptModel62.cdcc5ae3.png";